// ============================================================
// WISHLIST.JS — Handle bazlı, Cart Attributes + Cache
// ============================================================

const WishlistManager = (() => {
  let _cache = null;

  async function getAll() {
    if (_cache !== null) return _cache;
    try {
      const res = await fetch('/cart.js');
      const cart = await res.json();
      const val = cart.attributes?.wishlist;
      _cache = val ? JSON.parse(val) : [];
      return _cache;
    } catch { 
      _cache = [];
      return _cache;
    }
  }

  async function saveAll(handles) {
    _cache = [...new Set(handles)];
    try {
      await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ attributes: { wishlist: JSON.stringify(_cache) } })
      });
    } catch (e) { console.warn('Wishlist save failed:', e); }
  }

  async function toggle(handle) {
    const list = await getAll();
    const idx = list.indexOf(handle);
    if (idx === -1) list.push(handle);
    else list.splice(idx, 1);
    await saveAll(list);
    return idx === -1;
  }

  async function isWishlisted(handle) {
    return (await getAll()).includes(handle);
  }

  async function updateAllButtons() {
    const list = await getAll();
    const buttons = document.querySelectorAll('[data-wishlist-btn]');
    for (const btn of buttons) {
      const handle = btn.dataset.productHandle;
      if (!handle) continue;
      const active = list.includes(handle);
      btn.classList.toggle('wishlist-active', active);
      btn.setAttribute('aria-label', active ? 'Favorilerden çıkar' : 'Favorilere ekle');
    }
    updateBadge(list);
  }

  async function updateBadge(list) {
  const items = list || await getAll();
  const badge = document.querySelector('[data-wishlist-badge]');
  if (badge) {
    const count = badge.querySelector('.cart-bubble__text-count');
    if (count) count.textContent = items.length;
    badge.style.display = items.length > 0 ? '' : 'none';
  }
}

  async function init() {
    await updateAllButtons();
  }

  return { init, toggle, isWishlisted, getAll, saveAll, updateAllButtons, updateBadge };
})();

document.addEventListener('DOMContentLoaded', () => WishlistManager.init());

async function handleWishlistClick(btn) {
  const handle = btn.dataset.productHandle;
  if (!handle) return;

  // Hemen UI'ı güncelle
  const isActive = btn.classList.contains('wishlist-active');
  btn.classList.toggle('wishlist-active', !isActive);
  btn.setAttribute('aria-label', !isActive ? 'Favorilerden çıkar' : 'Favorilere ekle');

  // Arka planda kaydet
  await WishlistManager.toggle(handle);
  await WishlistManager.updateBadge();
}
